<template>
  <div class="sport-feature-placeholder">
    <MainNavbar />
    <main class="placeholder-content">
      <router-link :to="backRoute" class="back-link">
        <i class="fa-solid fa-arrow-left" aria-hidden="true" />
        Back
      </router-link>
      <section class="placeholder-card">
        <p class="pill">{{ sportLabel }}</p>
        <h1>{{ title }}</h1>
        <p>{{ description }}</p>
        <div class="actions">
          <router-link :to="primaryRoute" class="btn-primary">{{ primaryCta }}</router-link>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import MainNavbar from "@/components/main/headernfooter/header.vue";

export default {
  name: "SportFeaturePlaceholder",
  components: { MainNavbar },
  props: {
    sportLabel: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true },
    primaryCta: { type: String, default: "Open dashboard" },
    primaryRoute: { type: Object, required: true },
    backRoute: { type: Object, required: true },
  },
};
</script>

<style scoped>
.placeholder-content { padding: 96px 16px 24px; max-width: 980px; margin: 0 auto; }
.back-link { color: var(--text-color1); text-decoration: none; display: inline-flex; gap: 8px; margin-bottom: 14px; }
.placeholder-card { background: var(--background-color2); border: 1px solid var(--background-color3); border-radius: 12px; padding: 22px; }
.pill { display: inline-block; font-size: 12px; margin-bottom: 10px; }
.actions { margin-top: 14px; }
.btn-primary { background: var(--border-color-hover); color: #fff; text-decoration: none; padding: 10px 14px; border-radius: 8px; }
</style>
